import { createFileRoute } from '@tanstack/react-router';
import { WorkflowSettings } from '@/features/projects/settings/workflow-settings';

export const Route = createFileRoute('/_app/p/$projectKey/settings/workflow')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <WorkflowSettings projectKey={projectKey} />;
}
